import { IconComponent, themeColor, themeFontFamily } from 'LibNeo'
import styled, { css } from 'styled-components'

export const DatePickerWrapper = styled.div<{ requiredHighlight?: boolean }>`
	.ant-calendar-picker {
		width: 100%;
		.ant-calendar-picker-input,
		.ant-input {
			${({ requiredHighlight }) =>
				requiredHighlight &&
				css`
					border-color: ${themeColor('sun')} !important;
				`}
			&:focus,
			&:visited,
			&:active,
			&:hover {
				${({ requiredHighlight }) =>
					requiredHighlight &&
					css`
						border-color: ${themeColor('sun')} !important;
					`}
			}
		}
	}

	.ant-calendar-range-picker-separator {
		color: ${themeColor('gray', 6)};
	}
	.ant-calendar-picker-input,
	.ant-input {
		height: 40px;
		font-family: ${themeFontFamily('SBSansText')};
		font-style: normal;
		font-weight: normal;
		font-size: 14px;
		line-height: 20px;
		color: ${themeColor('extraBackground3')};
		padding: 10px 30px 10px 16px;
		border-radius: 6px;
	}
	.ant-calendar-range-middle {
		display: none;
	}
	.ant-calendar-picker-icon {
		width: 18px;
		height: 20px;
		margin-top: -10px;
	}
	.ant-calendar-picker-clear {
		width: 18px;
		height: 20px;

		background: ${themeColor('white')} url('/svg/delete.svg') no-repeat center center;
		margin-top: -10px;
		& svg {
			display: none;
		}
	}
	.ant-form-item-control.has-error .ant-form-explain {
		color: ${themeColor('pink', 5)};
		font-size: 12px;
		margin-top: 2px;
	}
`

export const CalendarWrapper = styled.div`
	.ant-calendar-picker-container {
		position: absolute;
		top: 0;
		left: 0;
		z-index: 5000;
	}
	.ant-calendar-range-picker-separator {
		color: ${themeColor('gray', 6)};
	}

	.ant-calendar-range-middle {
		margin-left: -154px;
	}

	.ant-calendar-cell {
		padding: 0;
	}
	.ant-calendar-input {
		color: ${themeColor('gray', 4)};
	}
	.ant-calendar-body {
		padding: 12px;
	}

	.ant-calendar-disabled-cell-first-of-row .ant-calendar-date {
		border-radius: 16px;
	}
	.ant-calendar {
		border-radius: 6px;
		width: 304px;
		&-range {
			width: 736px;
		}
	}
	.ant-calendar-selected-start-date.ant-calendar-selected-day .ant-calendar-date {
		border-radius: 4px 0 0 4px;
		color: ${themeColor('white')};
		background-color: ${themeColor('emerald', 5)};
		&:hover {
			background-color: ${themeColor('emerald', 5)};
		}
	}
	.ant-calendar-selected-start-date {
		position: relative;
		&:before {
			height: 40px;
			width: 5px;
			position: absolute;
			background-color: ${themeColor('emerald', 2)};
			content: '';
			left: 44px;
		}
	}
	.ant-calendar-selected-end-date {
		position: relative;
		&:before {
			height: 40px;
			width: 5px;
			position: absolute;
			background-color: ${themeColor('emerald', 2)};
			content: '';
			right: 44px;
		}
	}
	.ant-calendar-range-right .ant-calendar-date-input-wrap {
		margin-left: -244px;
	}
	.ant-calendar-selected-start-date.ant-calendar-selected-end-date {
		&:before {
			background: none;
		}
	}
	.ant-calendar-selected-start-date.ant-calendar-selected-end-date .ant-calendar-date {
		border-radius: 4px;
	}
	.ant-calendar-selected-end-date.ant-calendar-selected-day .ant-calendar-date {
		border-radius: 0 4px 4px 0;
		color: ${themeColor('white')};
		background-color: ${themeColor('emerald', 5)};
		&:hover {
			background-color: ${themeColor('emerald', 5)};
		}
	}
	.ant-calendar-disabled-cell .ant-calendar-date,
	.ant-calendar-time-picker-select li,
	.ant-calendar-date {
		width: 40px;
		height: 40px;
		border-radius: 4px;
		font-family: ${themeFontFamily('SBSansText')};
		color: ${themeColor('gray', 8)};
		font-size: 14px;
		font-weight: 400;
		line-height: 20px;
		text-align: center;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.ant-calendar-selected-day .ant-calendar-date,
	.ant-calendar-time-picker-select li:hover {
		background-color: ${themeColor('emerald', 2)};
	}
	.ant-calendar-date:hover {
		background-color: ${themeColor('emerald', 2)};
		border-radius: unset;
	}
	.ant-calendar-last-month-cell .ant-calendar-date,
	.ant-calendar-next-month-btn-day .ant-calendar-date {
		color: ${themeColor('gray', 4)};
		&:hover {
			color: ${themeColor('gray', 8)};
		}
	}
	.ant-calendar-time-picker-select li {
		margin: 16px 44px;
	}
	.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade {
		background-color: ${themeColor('emerald', 5)};
		display: flex;
		align-items: center;
		height: 40px;
		justify-content: center;
		border-radius: 6px;
	}
	.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month {
		background-color: ${themeColor('white')};
		display: flex;
		max-width: 60px;
		align-items: center;
		height: 40px;
		justify-content: center;
		border-radius: 6px;
		&:hover {
			background-color: ${themeColor('gray', 1)};
			color: ${themeColor('gray', 4)};
		}
	}
	.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month,
	.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year {
		background-color: ${themeColor('emerald', 5)};
		display: flex;
		max-width: 60px;
		align-items: center;
		height: 40px;
		justify-content: center;
		border-radius: 6px;
	}
	.ant-calendar-month-panel-month,
	.ant-calendar-year-panel-year {
		&:hover {
			background-color: ${themeColor('emerald', 1)};
			color: ${themeColor('emerald', 6)};
			display: flex;
			max-width: 60px;
			align-items: center;
			height: 40px;
			justify-content: center;
			border-radius: 6px;
		}
	}
	.ant-calendar-selected-date.ant-calendar-disabled-cell .ant-calendar-date {
		background-color: ${themeColor('gray', 1)};
		color: ${themeColor('gray', 4)};
	}
	.ant-calendar-input-wrap {
		height: 40px;
		display: flex;
		align-items: center;
	}
	.ant-calendar-my-select {
		font-family: ${themeFontFamily('SBSansText')};
	}
	.ant-calendar-selected-day .ant-calendar-date,
	.ant-calendar-today .ant-calendar-date {
		border-width: 0;
		color: ${themeColor('emerald', 6)};
		background-color: ${themeColor('white')};
	}
	.ant-calendar-time-picker-select li.ant-calendar-time-picker-select-option-selected,
	.ant-calendar-selected-date .ant-calendar-today .ant-calendar-date,
	.ant-calendar-selected-date .ant-calendar-date {
		background-color: ${themeColor('emerald', 5)};
		color: ${themeColor('white')};
	}
	.ant-calendar-in-range-cell .ant-calendar-date {
		color: ${themeColor('gray', 8)};
		background-color: ${themeColor('emerald', 2)};
	}
	.ant-calendar-in-range-cell {
		background-color: ${themeColor('emerald', 2)};
		&:before {
			background: none;
		}
	}
	.ant-calendar-range .ant-calendar-decade-panel,
	.ant-calendar-range .ant-calendar-year-panel,
	.ant-calendar-range .ant-calendar-month-panel {
		top: 40px;
	}
	.ant-calendar-header {
		& {
			padding: 0 8px;
		}
		& .ant-calendar-prev-century-btn,
		& .ant-calendar-prev-decade-btn,
		& .ant-calendar-prev-month-btn,
		& .ant-calendar-prev-year-btn,
		& .ant-calendar-next-century-btn,
		& .ant-calendar-next-decade-btn,
		& .ant-calendar-next-year-btn,
		& .ant-calendar-next-month-btn {
			& {
				padding: 0;
			}
			&:hover:after,
			&:hover:before {
				border-color: ${themeColor('emerald', 5)};
			}
			&:after,
			&:before {
				width: 10px;
				height: 10px;
				padding: 0;
				border-color: ${themeColor('gray', 4)};
				border-radius: 2px;
				border-width: 2px 0 0 2px;
			}
		}
		& .ant-calendar-next-century-btn::before,
		& .ant-calendar-next-decade-btn::before,
		& .ant-calendar-next-year-btn::before {
			left: 6px;
		}
		& .ant-calendar-prev-century-btn::after,
		& .ant-calendar-prev-decade-btn::after,
		& .ant-calendar-prev-year-btn::after {
			left: -5px;
		}
	}
	.ant-calendar-year-panel-next-decade-btn,
	.ant-calendar-year-panel-prev-decade-btn {
		&:hover:after,
		&:hover:before {
			border-color: ${themeColor('emerald', 5)};
		}
	}

	.ant-calendar-column-header .ant-calendar-column-header-inner {
		color: ${themeColor('gray', 6)};
		font-weight: 400;
		font-size: 12px;
		font-family: ${themeFontFamily('SBSansText')};
		line-height: 20px;
		padding: 0 0 6px 0;
	}
	.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date,
	.ant-calendar-disabled-cell .ant-calendar-date {
		background-color: white;
		color: ${themeColor('gray', 4)};
		&:before {
			display: none;
		}
	}
	.ant-calendar-time-picker-select {
		height: 322px;
	}
	.ant-calendar-time-picker-btn,
	.ant-calendar-today-btn {
		padding: 12px 8px;
		font-family: ${themeFontFamily('SBSansText')};
		color: ${themeColor('emerald', 6)};
		font-size: 12px;
		font-weight: 400;
		line-height: 20px;
		&:hover {
			color: ${themeColor('emerald', 7)};
		}
	}
	.ant-calendar .ant-calendar-ok-btn {
		&,
		&:visited,
		&:active,
		&:hover {
			height: 32px;
			padding: 8px;
			background-color: ${themeColor('emerald', 5)};
			border: 0;
			border-radius: 6px;
			outline: none;
			box-shadow: none;
			font-size: 12px;
			font-weight: 600;
			line-height: 16px;
			text-shadow: none;
		}
		&:hover {
			background-color: ${themeColor('emerald', 7)};
		}
		&.ant-calendar-ok-btn-disabled {
			background-color: ${themeColor('emerald', 1)};
			color: ${themeColor('white')};
		}
	}
`

export const Icon = styled(IconComponent)`
      position: absolute;
		svg {
			fill: ${themeColor('gray', 4)};
		}
	}
`
